/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toDoctorProps, toDoctorRequest } from './translator/doctor'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import {
  FetchDoctor,
  PostDoctor,
  FetchDoctorHospital,
  GetDoctor,
  PutDoctor,
  DeleteDoctor,
  PostDoctorInvitation
} from '@/infrastructure/network/Monitaro/requests/doctor'
import { IDoctorProps } from '@/entities/Doctor'

export default class Doctor extends MonitaroGatewayBase {
  async FetchDoctor(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchDoctor(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.doctors.map((prop) => toDoctorProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async FetchDoctorHospital(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchDoctorHospital(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.doctors.map((prop) => toDoctorProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async PostDoctor(params: IDoctorProps) {
    const { doctor } = await this.apiClient.request(new PostDoctor(toDoctorRequest(params)))
    return toDoctorProps(doctor)
  }

  async GetDoctor(id: string) {
    const { doctor } = await this.apiClient.request(new GetDoctor(id))
    return toDoctorProps(doctor)
  }

  async PutDoctor(id: string, params: IDoctorProps) {
    const { doctor } = await this.apiClient.request(new PutDoctor(id, toDoctorRequest(params)))
    return toDoctorProps(doctor)
  }

  async DeleteDoctor(id: string) {
    const { doctor } = await this.apiClient.request(new DeleteDoctor(id))
    return toDoctorProps(doctor)
  }

  async PostDoctorInvitation(hospital: string) {
    const { doctors } = await this.apiClient.request(new PostDoctorInvitation(hospital))
    return doctors.map(toDoctorProps)
  }
}
